import { Injectable, signal } from '@angular/core';

/**
 * Service to track and expose the test mode status.
 * Test mode is activated when the backend sends the X-Test-Mode header.
 */
@Injectable({
  providedIn: 'root',
})
export class TestModeService {
  /**
   * Signal that holds the current test mode status.
   * True when the backend is running in test mode (TestData:Enabled = true).
   */
  readonly isTestMode = signal<boolean>(false);

  /**
   * Updates the test mode status based on backend response headers.
   * Called by the TestModeInterceptor when it detects the X-Test-Mode header.
   */
  setTestMode(enabled: boolean): void {
    this.isTestMode.set(enabled);
  }
}
